<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <div class="plans-company">
      <h2>Plano da Empresa</h2>
      <form
        class="content-plans-register-form"
        @submit.prevent="handleSubmit()"
      >
        <div class="row">
          <div class="col-12">
            <div class="content-input-default-select">
              <label for="plan">Plano:</label>
              <div class="position-relative">
                <select
                  id="plan"
                  v-model="companyPlan.id_company_plans"
                  aria-label="plan-company"
                  :class="{
                    'content-input-default-select--active':
                      companyPlan.id_company_plans !== '',
                    'content-input-default-select--disabled':
                      companyPlan.is_active,
                  }"
                  required
                >
                  <option value="" selected>
                    Selecione o plano da empresa*
                  </option>
                  <option
                    v-for="plan in plans"
                    :key="plan.id"
                    :name="`plan-${plan.id}`"
                    :value="plan.id"
                    :disabled="
                      isPlanNotSupportCollaborators(
                        plan.number_of_collaborators
                      )
                    "
                  >
                    {{ plan.name }}
                    <span
                      v-if="
                        isPlanNotSupportCollaborators(
                          plan.number_of_collaborators
                        )
                      "
                    >
                      - Sem suporte - (Plano:
                      {{ plan.number_of_collaborators }} - Empresa:
                      {{ companyNumberOfCollaborators }})
                    </span>
                  </option>
                </select>
                <svg
                  width="7"
                  height="12"
                  viewBox="0 0 7 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_35_1490"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="7"
                    height="12"
                    style="mask-type: luminance"
                  >
                    <path
                      d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                      fill="white"
                    ></path>
                  </mask>
                  <g mask="url(#mask0_35_1490)">
                    <path
                      d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                      fill="black"
                    ></path>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="content-input-default">
              <label>Data de expiração do plano:</label>
              <input
                id="expiration_date"
                type="date"
                name="expiration_date"
                v-model="companyPlan.expiration_date"
                value=""
                required
              />
            </div>
          </div>
          <div
            class="content-switch"
            :class="{
              'content-switch--disabled':
                isDisabledHasPlanActive || isPlanExpired,
            }"
          >
            <div class="content-switch__div">
              <p class="content-switch__text">Plano está ativo?</p>
              <label class="switch">
                <input
                  type="checkbox"
                  name="is_active"
                  v-model="companyPlan.is_active"
                  :disabled="isDisabledHasPlanActive || isPlanExpired"
                />
                <span class="slider round"></span>
              </label>
            </div>
            <p
              v-if="isDisabledHasPlanActive"
              class="content-switch__text-disabled"
            >
              Desabilitado essa opção, porque existe outro plano ativo.
            </p>
            <p v-if="isPlanExpired" class="content-switch__text-disabled">
              Desabilitado essa opção, porque o plano está expirado.
            </p>
          </div>
          <div class="col-12">
            <button class="btn-green">Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Empresas",
          routerName: "ListCompanies",
        },
        {
          name: "Menu Empresa",
          routerName: "MenuCompany",
        },
        {
          name: "Planos",
          routerName: "ListPlansCompany",
        },
        {
          name: "Configurar Plano",
          routerName: "RegisterPlanCompany",
        },
      ],
      companyPlan: {
        id_company: "",
        id_company_plans: "",
        expiration_date: "",
        is_active: false,
      },
      dataProps: { module: "Company" },
    };
  },
  computed: {
    ...mapGetters({
      plans: "Company/plans",
      companyPlansData: "Company/companyPlans",
      hasPlanActive: "Company/hasPlanActive",
      companyNumberOfCollaborators: "Company/companyNumberOfCollaborators",
    }),
    hasParamsIdCompanyHasPlan() {
      return (
        Object.keys(this.$route?.params).length > 0 &&
        this.$route.params.idCompanyHasPlan
      );
    },
    hasCompanyPlan() {
      return (
        this.companyPlansData && Object.keys(this.companyPlansData).length > 0
      );
    },
    isDisabledHasPlanActive() {
      if (
        !this.hasParamsIdCompanyHasPlan ||
        !this.hasPlanActive ||
        Object.keys(this.hasPlanActive).length === 0
      ) {
        return false;
      }

      return this.hasPlanActive?.id !== this.$route.params.idCompanyHasPlan;
    },
    isPlanNotSupportCollaborators() {
      return (numberOfCollaborators) => {
        return (
          parseInt(this.companyNumberOfCollaborators) >
          parseInt(numberOfCollaborators)
        );
      };
    },
    isPlanExpired() {
      if (!this.companyPlan.expiration_date) {
        return false;
      }

      const expirationDate = this.companyPlan.expiration_date
        .split("-")
        .join("/");

      const dateExpiration = new Date(expirationDate);
      const yearExpiration = dateExpiration.getFullYear();
      const monthExpiration = dateExpiration.getMonth();
      const dayExpiration = dateExpiration.getDate() + 1;

      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate() + 1;

      const currentDateTime = new Date(year, month, day).getTime();
      const expirationDateTime = new Date(
        yearExpiration,
        monthExpiration,
        dayExpiration
      ).getTime();

      return currentDateTime > expirationDateTime;
    },
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions("Company", [
      "registerCompanyPlan",
      "consultCompanyPlans",
      "consultPlans",
    ]),
    async handleSubmit() {
      let message = this.companyPlan?.id
        ? "Plano da empresa editado com sucesso!"
        : "Plano da empresa cadastrado com sucesso!";

      this.companyPlan.id_company = this.$route.params.id;
      await this.registerCompanyPlan(this.companyPlan);
      this.$swal.fire({
        icon: "success",
        html: message,
      });
      console.log(this.$route.params);
      this.$router.push({
        name: "ListPlansCompany",
        params: {
          id: this.$route.params.id,
          slug: this.$route.params.slug,
        },
      });
    },
    handleDataBreadcrumb() {
      this.links[2].name = `Menu - ${this.$route.params.slug}`;
      this.links[2].routerParams = {
        params: {
          ...this.$route.params,
        },
      };
      this.links[3].routerParams = {
        params: {
          ...this.$route.params,
        },
      };
      this.links[4].name = "Configurar Plano";
    },
  },
  async mounted() {
    await this.consultPlans();
    this.handleDataBreadcrumb();

    if (this.hasParamsIdCompanyHasPlan) {
      await this.consultCompanyPlans(this.$route.params);
      if (this.hasCompanyPlan) {
        this.companyPlan = this.companyPlansData;
        this.companyPlan.expiration_date =
          this.$options.filters.formatDateToYearMonthDay(
            this.companyPlan.expiration_date
          );
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
  h2 {
    font-size: 24px;
    font-family: "Font Semibold";
    color: var(--black);
    text-align: left;
    margin-bottom: 50px;
  }
  .plans-company {
    position: relative;
    .content-switch {
      position: absolute;
      top: 30px;
      right: 0;
      &__div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      &__text {
        font-size: 12px;
        font-family: "Font Light";
        color: var(--black);
        margin-right: 10px;
        margin-bottom: 0;
        &-disabled {
          font-size: 10px;
          font-family: "Font Light";
          color: var(--black);
          margin-top: 5px;
          margin-bottom: 0;
        }
      }
      &--disabled {
        pointer-events: none;
        opacity: 0.5;
      }
      .switch {
        position: relative;
        display: inline-block;
        width: 51px;
        height: 26px;
        margin-bottom: 0;
      }
      /* Hide default HTML checkbox */
      .switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }
      /* The slider */
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--red-dark);
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
      .slider:before {
        position: absolute;
        content: "";
        height: 20px;
        width: 20px;
        left: 3px;
        bottom: 3px;
        background-color: var(--white);
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
      input:checked + .slider {
        background-color: var(--green);
      }
      input:checked + .slider:before {
        -webkit-transform: translateX(25px);
        -ms-transform: translateX(25px);
        transform: translateX(25px);
      }
      /* Rounded sliders */
      .slider.round {
        border-radius: 20px;
      }
      .slider.round:before {
        border-radius: 100%;
      }
    }
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
</style>
